import React, { useContext, useEffect } from 'react'

import { DataContext } from './DataContext'
import ExpandButton from '../../../elem/list/ExpandButton'
import TimeWindowSelectorButton from '../../../elem/chart/TimeWindowSelectorButton'
import { timeWindowOptions } from '../../../../utils/chart/timeWindow'
import ResetZoomButton from '../../../elem/chart/ResetZoomButton'
import SaveAsImageButton from '../../../elem/chart/SaveAsImageButton'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'

const ChartControls = ({ chartRef }) => {
    const {
        displayTimeWindowDropdown,
        toggleTimeWindowDropdown,
        timeWindow,
        resetZoom,
        visibleChartTab,
        detailData,
        isLoading,
    } = useContext(DataContext)
    const { chartExpanded, setChartExpanded } = useContext(DataContext)

    return (
        <div className="chartControlsWrapper columns">
            <div className="column is-10">
                <div className="columns is-justify-content-center">
                    <TimeWindowSelectorButton
                        inHeader={false}
                        timeWindow={timeWindow}
                        displayTimeWindowDropdown={displayTimeWindowDropdown}
                        toggleTimeWindowDropdown={toggleTimeWindowDropdown}
                    />
                    <ResetZoomButton resetFunction={resetZoom} />
                </div>
            </div>
            <div className="column is-2">
                <div className="columns">
                    <SaveAsImageButton
                        name="DetailsMenuNitrateChart"
                        componentRef={chartRef}
                        disabled={
                            isLoading ||
                            !(
                                detailData &&
                                detailData.nitrateChart &&
                                detailData.nitrateChart.length
                            )
                        }
                    />
                    <ExpandButton
                        name={`NitrateChart`}
                        isExpanded={chartExpanded}
                        setIsExpanded={setChartExpanded}
                        inHeader={false}
                    />
                </div>
            </div>
        </div>
    )
}

export default ChartControls
